export default {
  allocations: [],
  pagination: {},
  allocation: {}
}
